import React from "react";
import { useLocation } from "react-router-dom";

import PageHeader from "../../../../componets/PageHeader";
import NavBarTwo from "../../../../componets/NavBarTwo";
import stickerMakerUrls from "../../../../configs/sticker_maker/stickerMakerUrls";
import NavBarThree from "../../../../componets/NavBarThree";
import { PlusOutlined, SettingOutlined } from "@ant-design/icons";
import { setNewParams, setReorderIds } from "../../../../store/sticker_maker/categoriesSlice";
import { useAppDispatch, useAppSelector } from "../../../../store/hooks";
import { selectCategoryIds } from "../../../../store/sticker_maker/categoriesSlice";

const NAV_ITEMS: {[index: number]: any} = {
  1: {
    id: 1,
    name: 'Svg',
    url: stickerMakerUrls.assetsSvgPath()
  },
  2: {
    id: 2,
    name: 'Extras',
    url: stickerMakerUrls.assetsExtrasPath(),
    hasCategory: true
  }
};

const _PageHeader = () => {
  const dispatch      = useAppDispatch();
  const { pathname }  = useLocation();
  const activeItem    = Object.values(NAV_ITEMS).find(e => e.url === pathname);
  const ids           = useAppSelector(selectCategoryIds);

  function onClickCreate() {
    dispatch(setNewParams({ target: 2 }));
  }

  function onClickSettings() {
    dispatch(setReorderIds({ ids }));
  }

  return (
    <PageHeader
      title={activeItem?.name || 'All'}
      breadcrumbs={[activeItem?.name]}
    >
      <NavBarTwo
        items={NAV_ITEMS}
        itemIds={Object.keys(NAV_ITEMS)}
        activeId={activeItem?.id}
        parent={{
          name: 'All',
          url: stickerMakerUrls.assetsPath()
        }}
      />

      {
        activeItem?.hasCategory && <NavBarThree>
          <NavBarThree.Button onClick={onClickSettings}>
            <SettingOutlined /> Category Settings
          </NavBarThree.Button>
          <NavBarThree.Button onClick={onClickCreate}>
            <PlusOutlined /> Create Category
          </NavBarThree.Button>
        </NavBarThree>
      }
    </PageHeader>
  );
}

export default _PageHeader;
